import { createIcon } from '@chakra-ui/react';

export const BranchIcon = createIcon({
  displayName: 'BranchIcon',
  viewBox: '0 0 15 16',
  path: (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 0V7C1 8.65685 2.34315 10 4 10H15"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  ),
});
